import React from "react";
import { FaWhatsapp, FaPhone, FaEnvelope } from "react-icons/fa";

function Header() {
  return (
    <div className="header">
      <div className="contact-info">
        <FaWhatsapp className="icon" />
        <span> <a href="https://wa.me/+91992255589" target="_blank">Chat With Us </a></span>
        <span className="separator">|</span>

        <FaPhone className="icon" />
        <span>+91 9922555897</span>
        <span className="separator">|</span>

        <FaEnvelope className="icon" />
        <span>contact@adlrealtors.com</span>
        <span className="separator">|</span>

        <span className="maharera">MAHARERA: A041262401397</span>
      </div>
    </div>
  );
}

export default Header;
